import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css";

import { mfaNotify, mfaMigrate, mfaEmail, mfaStatus, emailVerify, emailChange } from "../services/MfaServices";
import Loader from "./../Loader";
import { translations } from "./../translations";
import { logoutRedirect } from "../utils/authutils";


class MfaModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      backButtonText: "Not Now",
      okButtonText: "Yes",
      bodyText: "",
      emailinput: false,
      email: "",
      timer : false,
      okPressed: false,
      hidefooter: false,
      title : "",
      errorButtonText: "", 
      errorMsgPart2: "",
      footershow: false,
      footermessage: "",
      alertVariant: null
    };
  }


 
  async componentDidMount() {
    
    await this.timer();
    this.setState({
      timer : false
    });
    const agent_id = localStorage.getItem("agent_id");
    
    let langCode = "";
    const resp = await mfaStatus(agent_id)
    const result = (await resp.json()).result
  
    
    langCode = localStorage.getItem("lang");
    if (!langCode || langCode === null) {
      langCode = "en";
    }
    this.setState({title: translations.mfa_title[langCode]})
    
    switch (result) {
      case "PENDING":
        this.setState({showModal: true});
        this.setState({
          bodyText: translations.pending[langCode],
          okButtonText: translations.yes[langCode],
          backButtonText: translations.not_now[langCode],
          footershow: false,
          

        });
        break;
      case "VERIFY" :
      case "NONE":
        this.setState({showModal: true});
        this.setState({
            bodyText: translations.verify[langCode] + "\n\n Email: ",
            emailinput: true,
            okButtonText: translations.confirm[langCode],
            backButtonText: translations.later[langCode],
            footershow: true,
            footermessage: translations.footer_1[langCode]
          });
        break;
      case "SUPPORT":
      case "ERROR":
      case "NOTIFY":
        this.setState({showModal: true});
        this.setState({
          bodyText: translations.support[langCode],
          hidefooter: true,
          okButtonText: translations.yes[langCode],
          backButtonText: translations.not_now[langCode],
          footershow: true,
          footermessage: translations.footer_3[langCode]
        });
        break;
  
      case "EMAIL":
        this.setState({showModal: true});
        this.setState({
          bodyText: translations.email[langCode],
          backButtonText: translations.later[langCode],
          okButtonText: translations.resend[langCode],
          footershow: false
        });
        break;
      case "KC": 
        this.setState({ showModal: false})
          // stop any active interval
        if (this.intervalID) {
          clearInterval(this.intervalID);
          this.intervalID = null;
        }
        // close modal and redirect (pass current location or omit arg)
        this.closeModal();
        logoutRedirect("https://go.invoxcontact.io/50/webagent/");
        
        break;
    }

}



refreshModal = async () => {
  try {
    const langCode = localStorage.getItem("lang");
    const agent_id = localStorage.getItem("agent_id");
    await this.timer();
    this.setState({
      timer : false
    });
    const resp = await mfaStatus(agent_id);
    const result = (await resp.json()).result;

    this.setState({title: translations.mfa_title[langCode]})
    this.setState({hidefooter: false});

    switch (result) {
      case "PENDING":
        this.setState({
          bodyText: translations.pending[langCode],
          okButtonText: translations.yes[langCode],
          backButtonText: translations.not_now[langCode],
          emailinput: false,
          footershow: false,
          
        });
        break;

      case "VERIFY":
      case "NONE":
        this.setState({
          bodyText: translations.verify[langCode] + "\n\n Email: ",
          emailinput: true,
          okButtonText: translations.confirm[langCode],
          backButtonText: translations.later[langCode],
          footershow: true,
          footermessage: translations.footer_1[langCode]

        });
        break;

      case "SUPPORT":
      case "ERROR":
      case "NOTIFY":
        this.setState({
          bodyText: translations.support[langCode],
          hidefooter: true,
          okButtonText: translations.yes[langCode],
          backButtonText: translations.not_now[langCode],
          footershow: true,
          footermessage: translations.footer_3[langCode]

        });
        break;
      case "EMAIL":
        this.setState({
          bodyText: translations.email[langCode],
          backButtonText: translations.later[langCode],
          okButtonText: translations.resend[langCode],
          emailinput: false,
          footershow: false

        });
        break;

      case "KC":
        
        this.setState({ showModal: false})
        if (this.intervalID) {
          clearInterval(this.intervalID);
          this.intervalID = null;
        }
        this.closeModal();
        logoutRedirect("https://go.invoxcontact.io/50/webagent/");

        break;

      default:
        // fallback
        break;
    }
  } catch (err) {
    this.setState({ bodyText: "Error refreshing MFA status" });
  }
};

  timer = () => {
    this.setState({
      timer: true,
      bodyText : false
    });
    return new Promise((resolve) => {  
      setTimeout(() => {
        resolve();
      }, 2000);
    })
  };

  timerButton = async (agent_id) => {
  while (true) {

    const resp = await mfaStatus(agent_id);
    const result = (await resp.json()).result;

    if (result === "PENDING" || result === "SUPPORT" || result === "KC" ) {
      this.refreshModal();
      return result;
    }

    await new Promise(r => setTimeout(r, 2000));
  }
};

  timerButtonEmail = (agent_id) => {
    return new Promise((resolve) => {  
      let x = 0;
      this.intervalID =  setInterval( async () => {
        
        const resp = await mfaStatus(agent_id);
        const result = (await resp.json()).result;
        if (result == "EMAIL"){ 
          this.setState({
            okPressed : false
          });
          clearInterval(this.intervalID)
         
          resolve();

        }else {
          x++;
        }

      }, 2000);
    })
  };

  closeModal = () => {
    // stop timer if active
    if (this.intervalID) {

      clearInterval(this.intervalID);
      this.intervalID = null;
    }
    // update internal state and notify parent if provided
    this.setState(
      {
        showErr: false,
        showModal: false,
      },
      () => {
        if (this.props.onClose) this.props.onClose();
      }
    );
  };

  confirmModal = async () =>{
    const langCode = localStorage.getItem("lang");
    
    const agent_id = localStorage.getItem("agent_id");
    const resp = await mfaStatus(agent_id)
    const result = (await resp.json()).result

    switch (result) {
      case "PENDING":
        this.setState({
          stateTEST : "SUPPORT",
        },
          () => { this.closeModal(); }
        );
        break;
      case "VERIFY":
      case "NONE":
        if (this.state.emailinput) {
          this.closeModal();
        } else {
          this.setState({
            emailinput: true,
          },
          () => { this.refreshModal(); }
          );
        }
        break;
      case "SUPPORT":
        this.closeModal();
        break;
      case "NOTIFY" || "ERROR":
        this.closeModal();
        break;
      case "EMAIL":
          this.closeModal();
        break;
      case "KC":
        break;
    }
  }
  clearFields = () => {
    this.setState({
      okButtonText: "",
      backButtonText: "",
      bodyText: "",
    });
  };
  handleAlertDismiss = () => {
    this.setState({
      showErr: false,
    });
  };

  
  handleOK = async() => {
    const langCode = localStorage.getItem("lang");

    const agent_id = localStorage.getItem("agent_id");
    const resp = await mfaStatus(agent_id)
    const result = (await resp.json()).result
    
    switch (result) {
      case "PENDING":
        await mfaMigrate(agent_id);
        this.setState({
          stateTEST : "EMAIL",
          
        },
          async () => { 
            await this.timer();
            this.setState({
              timer : false
            });
            this.timerButtonEmail(agent_id);
            const resp = await mfaStatus(agent_id)
            const result = (await resp.json()).result
            if (result == "EMAIL"){
              await mfaEmail(agent_id);
              this.refreshModal();
            }
           
            this.timerButton(agent_id); 

          }
        );
        break;
      case "VERIFY":
      case "NONE":
        if (this.state.emailinput) {
          if(this.state.email == "" || this.state.email == localStorage.getItem("email")){
            const resp = await emailVerify(agent_id);
            const result = (await resp.json()).result;
            if (result == "VERIFY"){
              this.setState({
                  bodyText:  translations.check_email_verify[langCode],
                  okButtonText: translations.resend[langCode],
                  emailinput: false,
                  backButtonText: translations.back[langCode],
                  footershow: true,
                  footermessage: translations.footer_2[langCode]
                  //okPressed : true

                }, () =>{this.timerButton(agent_id)}
                );
            }
            else {
              this.setState({
                showErr: true,
                errorMsg: translations.error_email_change_part1[langCode],
                errorButtonText: translations.notify_error_email[langCode],
                errorMsgPart2: translations.error_email_change_part2[langCode]
              });
            }
          } else {
            if (!this.validarEmail(this.state.email)){
            this.setState({
              showErr: true,
              errorMsg: translations.error_email_change_part1[langCode],
              errorButtonText: translations.notify_error_email[langCode],
              errorMsgPart2: translations.error_email_change_part2[langCode]
            });
            return;
            }
            const response = await (await emailChange(agent_id, this.state.email)).json();
            if (response.result == true){
              await emailVerify(agent_id);
              this.setState({
                bodyText:  translations.check_email_verify[langCode],
                okButtonText: translations.resend[langCode],
                emailinput: false,
                backButtonText: false,
                footershow: true,
                footermessage: translations.footer_2[langCode]  
                //okPressed : true

              }, () =>{this.timerButton(agent_id)}
              );
            }
            else {
              this.setState({
                showErr: true,
                errorMsg: translations.error_email_change_part1[langCode],
                errorButtonText: translations.notify_error_email[langCode],
                errorMsgPart2: translations.error_email_change_part2[langCode]
              });
            }
          
          }
        } else {
          await emailVerify(agent_id); 
        }
        break;
      case "SUPPORT":
        this.closeModal();
        break;
      case "NOTIFY":
      case "ERROR":
        this.closeModal();
        break;
      case "EMAIL":
        await mfaEmail(agent_id);
        this.setState({
          bodyText: translations.email[langCode],
          backButtonText: translations.later[langCode],
          okButtonText: translations.resend[langCode],
        },
          () => { this.timerButton(agent_id); }
        );
        break;
      case "KC":
        break;
    }
      
  };
  setEmail = (event) => {

    this.setState({email : event.target.value });
    if (!this.validarEmail(event.target.value) && event.target.value != ""){
      this.setState({
        showErr: true,
        errorMsg: translations.error_format[localStorage.getItem("lang")],
        errorButtonText: "",
        alertVariant: null,
        errorMsgPart2: ""
      });
    }else{
      this.setState({
        showErr: false,
      });
    }

  };
  protect_email = (user_email) => {
    
    var part1, part2;
    const split = user_email.split("@");
    part1 = user_email.slice(0, 3);
    part2 = user_email.slice(-6);
    
    return part1 + "*".repeat(split[0].length) + "@" + "*".repeat(split[1].length) + part2;
  };

  validarEmail = (email) => {
    // Expresión regular para validar un correo electrónico
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/;
    return regex.test(email);
  };

  notified = async () => {
    await mfaNotify(localStorage.getItem("agent_id"), this.state.email);
    this.setState({
      showErr: true,
      errorMsg: translations.notified[localStorage.getItem("lang")],
      errorButtonText: "", 
      alertVariant: "success",
      errorMsgPart2: ""
    });
  }; 
  handleExit = () => { };
  render() {
    const show = this.props.show !== undefined ? !!this.props.show : !!this.state.showModal;

    return (
      <Modal
        show={show}
        onHide={this.closeModal}
        dialogClassName="redirectModal"
        centered
        className={`lang-modal-${this.props.theme} text-center font-weight-bold h-full`}
      >
        <Modal.Header closeButton>
          <Modal.Title>{this.state.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center" style={{ minHeight: "100px", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", textAlign: "center", marginTop: "15px" }}>
            {this.state.timer && <Loader customStyle="h-5" width="20px" height="20px" />}
            <p className="h5" style={{ whiteSpace: "pre-line" }}>{this.state.bodyText}</p>
            {this.state.emailinput && this.state.timer === false && (
              <input
                id="newemail"
                type="text"
                className="email-input"
                onChange={(email) => this.setEmail(email)}
                value={this.state.email}
                placeholder={this.protect_email(localStorage.getItem("email"))}
                style={{
                  width: "150%",       // 50% bigger
                  height: "30px",
                  maxWidth: "600px",   // avoid excessive overflow
                  padding: "8px 10px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                 
                }}
              />
            )}
            {this.state.footershow && (
              <p className="h6" style={{ whiteSpace: "pre-line", padding: "15px" , marginBottom: "10px"}}>{this.state.footermessage}</p>
            )}
          </div>
          {this.state.showErr && (
            <div className="alertWrapper">
              <Alert
                bsStyle={this.state.alertVariant || "danger"}
                style={{ display: "block", opacity: 1, fontSize: "12.5px" , marginTop: "10px", marginBottom: "0px"}}
                onClose={() => this.handleAlertDismiss()}
              >
                <p>
                  {this.state.errorMsg}
                  <span
                    onClick={() => { this.notified(); }}
                    style={{ color: "#5c0909ff", textDecoration: "underline", cursor: "pointer" }}
                  >
                    {this.state.errorButtonText}
                  </span>
                  {this.state.errorMsgPart2}
                </p>
              </Alert>
            </div>
          )}
        </Modal.Body>
        {!this.state.hidefooter && (
          <Modal.Footer style={{ textAlign: 'center', padding: '0 0 15px 0' }}>
            <button
              className="btn btn-default btn-lg"
              onClick={this.confirmModal}
              disabled={this.state.timer}
              style={{ marginRight: 10 }}
            >
              {this.state.backButtonText || "Cancel"}
            </button>

            <button
              className="btn btn-primary btn-lg"
              onClick={this.handleOK}
              disabled={this.state.timer || this.state.okPressed}
            >
              {this.state.okButtonText || "OK"}
            </button>
          </Modal.Footer>

        )}
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    showCallForwardData:
      !state.callForward.is_loading_inconditional &&
      !state.callForward.is_loading_conditional,
    inconditional_call_forward: state.callForward.inconditional_call_forward,
    inconditional_call_forward_phone:
      state.callForward.inconditional_call_forward_phone,
    busy_call_forward: state.callForward.busy_call_forward,
    busy_call_forward_phone: state.callForward.busy_call_forward_phone,
    no_answer_call_forward: state.callForward.no_answer_call_forward,
    no_answer_call_forward_phone:
      state.callForward.no_answer_call_forward_phone,
    no_answer_call_forward_time: state.callForward.no_answer_call_forward_time,
    showCallForwardErr: state.callForward.showCallForwardErr,
    showSaveError: state.callForward.showSaveError,
    saveErrorMessage: state.callForward.saveErrorMessage,
    isEditing: state.callForward.isEditing,
    agentConfig: state.agentConfig,
    translations: state.common.translations,
    langCode: state.common.language,
    selectedLanguage: state.common.language,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {

    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(MfaModal);



// WEBPACK FOOTER //
// ./src/popups/MfaModal.js